import { render, staticRenderFns } from "./company-expat.vue?vue&type=template&id=2c77b5ec&scoped=true"
import script from "./company-expat.vue?vue&type=script&lang=js"
export * from "./company-expat.vue?vue&type=script&lang=js"
import style0 from "./company-expat.vue?vue&type=style&index=0&id=2c77b5ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c77b5ec",
  null
  
)

export default component.exports